import React from 'react';

import AdminLayout from '../AdminLayout';
import PhotoImages from './PhotoImages/PhotoImages';
const DefaultImagesContainer = () => {
  return (
    <AdminLayout>
      <PhotoImages />
    </AdminLayout>
  );
};

export default DefaultImagesContainer;
